module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "autocomplete"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.suggestions,
      "item-text": "nama",
      "return-object": "",
      "placeholder": "Cari berdasarkan bab/subbab",
      "outlined": "",
      "rules": _vm.rules
    },
    on: {
      "change": _vm.choose,
      "click": _vm.search
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68b3a756","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/global/components/plugins/Autocomplete.vue
// module id = 1500
// module chunks = 1